

export const wanSteps = {
    title: '如何用 3 步生成含音频的视频',
    sub: '使用 Wan 2.5 生成含同步音频的专业视频。无需音频剪辑技能 — 对白、音乐与音效会随视频自动生成。',
    items: [
      { num: '1', title: '步骤 1：选择文字或图片输入', text: '文字转视频：描述你的场景、运镜、动作与音频需求。图片转视频：上传参考图片并描述期望运动。Wan 2.5 会生成匹配的音频，包括对白、音乐与环境声。' },
      { num: '2', title: '步骤 2：设置时长、分辨率与比例', text: '时长：5 秒（快速内容）或 10 秒（更丰富叙事）。分辨率：720p（速度较快）或 1080p（最高质量）。比例：16:9 横向、9:16 纵向或 1:1 方形。可选：使用反向提示排除不需要元素。' },
      { num: '3', title: '步骤 3：生成并下载（原生音频）', text: '点击生成，Wan 2.5 在数分钟内产出含同步音频的视频。预览完整视频含对白唇形与背景音乐。下载即可用于 YouTube、TikTok、Instagram 或商业项目。' }
    ],
  };
